export default __webpack_public_path__ + "static/media/fevr-bm-icon-4.0d06be08.svg";